import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'

const getUI = state => state.ui

const storeFilterSearchDelaySelector = createSelector(
	[ getUI ],
	uiData => ({
		autoSearch: (
			[
				viewTypes.STORE_LANDING,
				viewTypes.STORE_SEARCH,
				viewTypes.STORE_FOLDER,
				viewTypes.VIDEO_CREATE,
				viewTypes.INTERACTIVE_VIDEO_CREATE,
				viewTypes.VIDEO_STANDALONE_CREATE,
				viewTypes.TIME_TO_CLIMB_CREATION,
				viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION,
				viewTypes.DRAW_IT_CREATION,
				viewTypes.DRAW_IT_STANDALONE_CREATION,
				viewTypes.MATCHING_PAIRS_CREATION,
				viewTypes.MATCHING_PAIRS_STANDALONE_CREATION,
			].includes(uiData.currentView)
		),
	})
)

export default storeFilterSearchDelaySelector
